export const AD_TYPES = {
  image: {
    id: 'image',
    label: 'label.IMAGE'
  },
  text: {
    id: 'text',
    label: 'label.TEXT'
  }
};

export const LINK_TYPES = {
  doc: {
    id: 'doc',
    label: 'label.DOCUMENT'
  },
  url: {
    id: 'url',
    label: 'label.URL'
  },
  video: {
    id: 'video',
    label: 'label.VIDEO'
  }
};
